import { useQuery } from '@tanstack/react-query';

import { getTasks } from '../client';
import { useSimulationId } from './useSimulationId';

export function useTeamTasks(teamName: string) {
  const simId = useSimulationId();

  return useQuery({
    queryKey: ['team-tasks', simId, teamName],
    queryFn: () =>
      getTasks({ path: { sim_id: simId }, query: { team: teamName }, throwOnError: true }).then(({ data }) => data),
    refetchInterval: 30_000,
  });
}
